import { useState, useEffect } from 'react';

type GridView = 'table' | 'card';

const GRID_VIEW_KEY = 'preferred_grid_view';

export function useGridView(defaultView: GridView = 'table') {
  const [view, setView] = useState<GridView>(() => {
    try {
      const saved = localStorage.getItem(GRID_VIEW_KEY);
      return (saved as GridView) || defaultView;
    } catch {
      return defaultView;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(GRID_VIEW_KEY, view);
    } catch {
      // localStorage might not be available
    }
  }, [view]);

  return {
    view,
    setView,
    isTableView: view === 'table',
    isCardView: view === 'card'
  };
}
